import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Info from '../../../../../../components/channel-configuration/info';
import { InputSelect } from '../../../../../../components/input/select';
import { useBackdropContext } from '../../../../../../context/backdrop';
import { MeterPurposeInternal } from '../../../../../../data-access/gql-types/graphql';
import { useSetMeterPurpose } from '../../../../api/meter/meter.hooks';
import { useDevicesAndChannelsContext } from '../../../../context/devices-and-channels';
import { ChannelMeterTypeOrUndefined } from '../../../../types';
import { MeterPurposeInternalRequest } from '../../../../types/graphql-rest-converter';

type MeterPurposeProps = {
  setTimeoutError: () => void;
};

const MeterPurpose: React.FC<MeterPurposeProps> = ({ setTimeoutError }) => {
  const { t } = useTranslation('configuration');
  const { channelId } = useParams<{ channelId: string }>();
  const { channel } = useDevicesAndChannelsContext();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const { mutate } = useSetMeterPurpose();

  const onChangePurpose = (value: MeterPurposeInternal) => {
    if (!channelId) return;

    if (meterPurpose !== value && channel) {
      turnOnBackdrop();

      mutate(
        { channelId, value: MeterPurposeInternalRequest[value] },
        {
          onSuccess: () => {
            setTimeoutError();
          },
          onError: () => {
            turnOffBackdrop();
          },
        },
      );
    }
  };

  const meterPurpose = (channel?.data as ChannelMeterTypeOrUndefined)?.meterPurpose;

  return (
    <>
      <hr />
      <Info title={t('meterPurpose.purpose')} />
      <InputSelect
        value={meterPurpose}
        onChange={onChangePurpose}
        options={[
          { label: t('meterPurpose.main'), value: MeterPurposeInternal.Main },
          { label: t('meterPurpose.pv'), value: MeterPurposeInternal.Pv },
          { label: t('meterPurpose.energyStorage'), value: MeterPurposeInternal.EnergyStorage },
          { label: t('meterPurpose.consumption'), value: MeterPurposeInternal.Consumption },
        ]}
        label={''}
      />
    </>
  );
};

export default MeterPurpose;
